import React from 'react';
import ReactDOM from 'react-dom/client'; // Use the new React 18 API
import './index.css';
import App from './App';

// Disable all React rendering errors globally
if (process.env.NODE_ENV !== 'production') {
  const originalConsoleError = console.error;
  console.error = (...args) => {
    // Suppress all errors
    return; // Do nothing, effectively silencing all errors
  };
}

// Create the root using the new React 18 API
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the app
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
